import styled from 'styled-components';

const IconsWrap = styled.div.withConfig({
    displayName: "styles__IconsWrap",
    componentId: "sc-fe0325f0-0"
})`
    display: flex;
    margin-top: ${({ theme  })=>theme.spacers.M};
`;
const Circle = styled.div.withConfig({
    displayName: "styles__Circle",
    componentId: "sc-fe0325f0-1"
})`
    width: 48px;
    height: 48px;
    grid-area: icon;
    place-self: center left;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
`;
const CircleBackground = styled.div.withConfig({
    displayName: "styles__CircleBackground",
    componentId: "sc-fe0325f0-2"
})`
    background-color: ${({ theme  })=>theme.colors.Color2_75};
    opacity: 0.1;
    position: absolute;
    width: 100%;
    height: 100%;
`;
const IconContainer = styled.div.withConfig({
    displayName: "styles__IconContainer",
    componentId: "sc-fe0325f0-3"
})`
    cursor: pointer;
    &:first-child {
        margin-right: ${({ theme  })=>theme.spacers.M};
    }
`;
const Title = styled.h2.withConfig({
    displayName: "styles__Title",
    componentId: "sc-fe0325f0-4"
})`
    ${({ theme  })=>theme.typography.SuperTinyHeadline};
    color: ${({ theme  })=>theme.colors.Foreground};
    padding-bottom: ${({ theme  })=>theme.spacers.M};
    padding-right: ${({ theme  })=>theme.spacers.XL};
`;
const Paragraph = styled.p.withConfig({
    displayName: "styles__Paragraph",
    componentId: "sc-fe0325f0-5"
})`
    ${({ theme  })=>theme.typography.Paragraph};
    color: ${({ theme  })=>theme.colors["Level 5"]};
`;
const StyledTextArea = styled.textarea.attrs({
    rows: 1,
    maxLength: 1000
}).withConfig({
    displayName: "styles__StyledTextArea",
    componentId: "sc-fe0325f0-6"
})`
    width: 100%;
    height: 92px;
    border: 1px solid ${({ theme  })=>theme.colors["Level 1"]};
    box-sizing: border-box;
    border-radius: 4px;
    /* resetting default styles */
    resize: none;
    overflow: hidden;
    outline: none;
    outline-offset: 0;
    box-shadow: none;
    background: none;
    color: ${({ theme  })=>theme.colors["Level 5"]};
    padding: ${({ theme  })=>theme.spacers.M};
    ${({ theme  })=>theme.typography.Paragraph};
    text-align: left;
    margin: ${({ theme  })=>theme.spacers.M} 0;
`;

export { Circle, CircleBackground, IconContainer, IconsWrap, Paragraph, StyledTextArea, Title };
